import {
    TBuyerAdditionalDetails,
    THomeserveOfferDetails,
} from '@pb/apps/offers/context/offer-details';
import { TSessionBuyerDetails } from './buyer-offer-session.types';

export const initialBuyerDetails: TSessionBuyerDetails = {
    id: 0,
    name: '',
    offerId: 0,
    forename: '',
    middlename: '',
    surname: '',
    email: '',
    phone: '',
    addressId: undefined,
    addressLine1: '',
    addressLine2: '',
    town: '',
    county: '',
    postCode: '',
    dateOfBirth: '',
    usePrimary: false,
};

export const initialBuyerAdditionalDetails: TBuyerAdditionalDetails = {
    mortgageAgreementStatus: 'NotYetArranged',
    propertyId: 0,
};

export const initialHomeserveOfferDetails: THomeserveOfferDetails = {
    byEmail: false,
    byPhone: false,
    byPost: false,
    bySms: false,
    offerId: 0,
    proceedWithoutExtra: false,
    propertyIsPermanentResidence: false,
    propertyIsRetailCommercialOrBusiness: false,
};
